import { IEntityFragment, IMappingProfile } from '@pf/shared-common';
import {
    FragmentMappingConfig,
    InteroperableMetadata,
    InteroperableMetadataMap,
} from '../fragment-mapping-config';
import { PlatformWmsFragments } from './platform-wms-fragments.enum';
import { IUserFragment, UserFragmentSymbol } from '../core/user-fragment';

export interface IPickListFragment extends IEntityFragment {
    id: string;
    status: string;
    pickByDate: string;
    organizedByUser: IUserFragment;
    assignedToUser: IUserFragment;
}

export type IPickListFragmentDto = IPickListFragment;

export function PickListFragmentMetadataMap<
    TFragmentDto extends IPickListFragmentDto,
    TFragment extends IPickListFragment,
>(config: FragmentMappingConfig<TFragmentDto, TFragment>): IMappingProfile {
    const interoperableMetadata = {
        status: String,
        pickByDate: String,
        organizedByUser: UserFragmentSymbol,
        assignedToUser: UserFragmentSymbol,
    } as InteroperableMetadata<TFragmentDto, TFragment>;
    return InteroperableMetadataMap(
        PlatformWmsFragments.PickList,
        interoperableMetadata,
        config
    );
}

export const DefaultPickListFragmentMetadataMap = PickListFragmentMetadataMap<
    IPickListFragmentDto,
    IPickListFragment
>({});
